<xemex-card
  [title]="'locations.installations.title' | translate"
  [loading]="loading()"
  [actionLabel]="total() > 0 ? ('general.btnViewAll' | translate) : undefined"
  actionIcon="arrow_forward"
  (action)="viewAll()"
>
  @if (canCreate()) {
    <div class="mb-3">
      <xemex-filled-button type="button" icon="add" (click)="create()">
        {{ 'installations.create.action' | translate }}
      </xemex-filled-button>
    </div>
  }

  @if (failed()) {
    <p class="m-0 text-text-error" role="alert" data-testid="installations-failed">
      {{ 'locations.installations.loadFailed' | translate }}
    </p>
  } @else if (!installations().length) {
    <p class="m-0 text-text-secondary" data-testid="installations-empty">
      {{ 'locations.installations.empty' | translate }}
    </p>
  } @else {
    <ul class="m-0 flex list-none flex-col divide-y divide-border-default p-0">
      @for (installation of installations(); track installation.installationOid) {
        <li
          class="flex flex-wrap items-center justify-between gap-3 py-2.5 first:pt-0 last:pb-0"
          data-testid="location-installation"
        >
          <a
            class="min-w-0 truncate font-semibold text-text-link"
            data-testid="location-installation-link"
            [routerLink]="['/', APP_PATHS.Installations, installation.installationOid, 'general']"
            >{{ installation.name }}</a
          >
          <span class="flex items-center gap-2">
            <xemex-status-chip
              dot
              [status]="statusChip(installation.status)"
              [label]="'installations.status.' + installation.status | translate"
            />
            @if (installation.commissioningComplete !== null) {
              <xemex-status-chip
                dot
                [status]="commissioningChip(installation.commissioningComplete)"
                [label]="
                  (installation.commissioningComplete
                    ? 'installations.commissioning.badge.complete'
                    : 'installations.commissioning.badge.incomplete'
                  ) | translate
                "
              />
            }
          </span>
        </li>
      }
    </ul>
  }
</xemex-card>
